<template>
  <div class="w-full">
      <cabecera-web></cabecera-web>
    <div v-if="establecimientoActual" class="py-5 block md:flex max-w-screen-xl mx-auto">
      
      <div class="w-full md:w-1/2">
        <ver-item :establecimientoActual="establecimientoActual" ></ver-item>
      </div>
      <div class="w-full md:w-1/2">
        <contenido-iframe :establecimientoActual="establecimientoActual" ></contenido-iframe>
      </div>
    </div>
  </div>
</template>
<script>

import VerItem from '@/components/EditarItem'
import ContenidoIframe from '@/components/Iframe'
import CabeceraWeb from "@/components/Cabecera"
export default {
  mounted() {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth"
    });
  },
  props: ['id'],
  components: {
    VerItem,
    CabeceraWeb,
    ContenidoIframe
  },
  computed: {
    establecimientoActual(){
      // const respuesta = this.$store.getters.establecimientoActual(this.id)
      // console.log('Respuesta', respuesta)
      const establecimientoActual = this.$store.state.bonoActual
      if (establecimientoActual.hasOwnProperty('NOMBRE')) {
          return establecimientoActual        
      } else {
        this.$router.push(`/${this.$i18n.locale}/establecimientos`)
      }
    }
  }
}
</script>